import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {ErrorCode} from "../enums/error-codes";
import {User} from "../entities/user/user";
import {UserService} from "../users/user.service";
import {Pagination} from "../entities/pagination";
import {Sorting} from "../entities/sorting";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription, Subject} from "rxjs";
import {GroupType} from "../enums/group-type.enum";
import {ModalComponent} from "ng2-bs3-modal/components/modal";
import {FormGroup, FormBuilder} from "@angular/forms";
import {BusinessType} from "../enums/business-type";
import {CountryService} from "../country.service";
import {HttpClient} from "../http.client";

export class Size {
  minimum: number = -1;
  maximum: number = -1;
  range1: boolean = false;
  range2: boolean = false;
  range3: boolean = false;
  range4: boolean = false;
  range5: boolean = false;
  range6: boolean = false;
  range7: boolean = false;
  range8: boolean = false;
  range9: boolean = false;
  range10: boolean = false;
}
export class Fancy {
  straight_color:boolean = false;
  intensity: string[] = [];
}
export class White {
  cut: string[] = [];
}
export class Attr {
  name: string;
  value: string;
  lot_id: any;
}

export class Collection {
    id: number;
    name: string;
    description: string;
    shape: string[] = [];
    size: Size = new Size();
    price: {
      minimum: number;
      maximum: number;
    };
    clarity: string[] = [];
    color: string[] = [];
    polish: string[] = [];
    symmetry: string[] = [];
    fluorescence: string[] = [];
    lab: string[] = [];
    find_pair: boolean = false;
    mounted: boolean = false;
    location: string[] = [];
    lot_id: string[] = [];
    search_type: number = 1;
    fancy: Fancy = new Fancy();
    white: White = new White();
    display_order: number;
    image: string;
}


@Component({
  selector: 'jewlary',
  templateUrl: './jewlary.component.html',
  styleUrls: ['./jewlary.component.css']
})

export class JewlaryComponent implements OnInit {
    filter = {
      jewelryType: '0',
      diamondType: 0,
      search: '',
    }
    newAttr = new Attr();
    lotIds: any[] = [];
    sub: any;
    page: any = 1;
    requestInProgress: boolean;
    currentItem: any;
    diamonds: any[] = [];
    fdiamonds: any[] = [];
    jewelryTypes: any[] = [];
    @ViewChild('lotIdsSelect') lotIdsSelect;

    locations: any[] = [];

    public shape:Array<string> =
    ['BR', 'RA', 'CU', 'EM',
    'SQEM', 'CARRE','PR', 'PS', 'OV',
    'HS', 'MQ', 'other'];

    public clarity:Array<string> =
    ['FL', 'IF', 'VVS1', 'VVS2',
    'VS1', 'VS2','SI1', 'SI2-'];

    public color:Array<string> =
    ['D', 'E', 'F', 'G',
    'H', 'I','J', 'K', 'L-O'];

    public fcolor:Array<string> =
    ['Yellow', 'Orange', 'Pink', 'Purple',
    'Blue', 'Green', 'Red', 'Brown'];

    public polish:Array<string> =
    ['EX', 'VG', 'G', 'G-'];

    public symmetry:Array<string> =
    ['EX', 'VG', 'G', 'G-'];

    public fluorescence:Array<string> =
    ['NON', 'FNT', 'MED', 'STRONG'];

    public lab:Array<string> =
    ['GIA', 'HRD', 'OTHER'];

    public intensity:Array<string> =
    ['Light', 'Fancy Light', 'Fancy', 'Intense',
    'Deep', 'Vivid'];

    public cut:Array<string> =
    ['EX', 'VG', 'G', 'G-'];

    private results: any[];
    public pagination2 = {
      perPage: 25,
      lastPage: 1,
      currentPage: 1,
      itemCount: 0
    }

    @ViewChild('image') el:ElementRef;
    @ViewChild('imgInput') imgInput:ElementRef;

    imageBace: string = '';
    isLoading = true;
    isNew = false;
    errorFromServer = ErrorCode.Success;
    pagination: Pagination;
    sorting: Sorting;
    collections: Collection[];
    groupTypes = GroupType;
    @ViewChild('modal')
    modal: ModalComponent;
    editingUser:Collection = new Collection();
    form: FormGroup;
    businessTypes = BusinessType;
    displayPocSelection = false;
    search: string = "";
    private _searchStrem = new Subject<string>();

    private _subscription: Subscription;

    constructor(private _userService: UserService,
                private _http: HttpClient,
                private element: ElementRef,
                private route: ActivatedRoute,
                private router: Router,
                private _builder: FormBuilder,
                private _countryService: CountryService) {
    }

    private buildForm() {
        this.form = this._builder.group({
            role: [
                ''
            ],
            poc: [
                ''
            ],
            defaultMarkup: [
                ''
            ]
        });
    }

    getList(page:any){
      this.page = page;

      this.pagination2.lastPage = Math.ceil(this.fdiamonds.length / (+this.pagination2.perPage));
      this.pagination2.itemCount = this.fdiamonds.length;
      let end:number;
      if(page == this.pagination2.lastPage) {
        end = (+this.pagination2.itemCount);
      }else{
        end = (page-1) * (+this.pagination2.perPage) + (+this.pagination2.perPage);
      };
      this.results = this.fdiamonds.slice((page-1) * (+this.pagination2.perPage), end);
      this.pagination2.currentPage = page;
      console.log(this.pagination2)
    }

    ngOnInit() {

      this.sub = this.route.queryParams.subscribe((params: any) => {
        this.filter.search = params['search'] || '';
        this.filter.jewelryType = params['jewelryType'] || '0';
        this.filter.diamondType = params['diamondType'] || 0;

        this.filterDiamonds();
      });
        this.getDiamondList()
        this.buildForm();

        this._searchStrem
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe(search => {
              this.groupTypeChange(search);
            });
    }
    filterDiamonds(){
      if(this.diamonds) {

                this.isLoading = true;
        this.fdiamonds = [];
        this.diamonds.forEach((el) => {
          let flag = true;

          if(this.filter.diamondType != 0) {
            if(el.diamond_type != this.filter.diamondType) {
              flag = false;
            }
          }
          if(flag && this.filter.jewelryType != '0') {
            if(el.mounted != this.filter.jewelryType) {
              flag = false;
            }
          }
          if(flag && this.filter.search) {
            if(el.lot_id.toString().indexOf(this.filter.search) == -1) {
              flag = false;
            }
          }
          if(flag) {
            this.fdiamonds.push(el);
          }
        })
        this.isLoading = false;
        this.getList((this.page || 1));
      }
    }
    groupTypeChange(search?:string) {
        if(search !== undefined) {
          this.filter.search = search;
        }
        this.router.navigate(['/jewelries'], {queryParams: this.filter});
        this.filterDiamonds();
        /*
        let usersGroup = this.editingUser.permissions.group_id;

        this.displayPocSelection = usersGroup == GroupType.Client || usersGroup == GroupType.Collaborator || usersGroup == GroupType.Viewer;*/
    }

    openEditModal(user?: any) {
      if(user) {
        this.isNew = false;
        let tmp = JSON.stringify(user)
        this.editingUser = JSON.parse(tmp);
        this.modal.open();
      }else{
        this.isNew = true;
        this.editingUser = new Collection();
        this.editingUser.price = {
          minimum: -1,
          maximum: -1,
        }
        this.modal.open();
      }
    }
    openModal(user:any, modalFrom:any){//imageModal
      let tmp = JSON.stringify(user)
      this.editingUser = JSON.parse(tmp);
      modalFrom.open();
    }
    save() {
      this.requestInProgress = true;
    }

    getAttr(){
      this.newAttr = new Attr();
      this.newAttr.lot_id = this.currentItem.lot_id;
      console.log(this.currentItem)
        this._http.get(
            "/diamond/getAttributes?lot_id=" + this.currentItem.lot_id
        ).subscribe(items => {
          this.currentItem.attributes = items.attributes;
            });

    }

    createAttr(){
        if(!this.newAttr.value || !this.newAttr.name) {
          return
        }
        this.requestInProgress = true;
        this._http.post(
            "/diamond/createAttribute",
            this.newAttr
        ).subscribe(items => {
          this.requestInProgress = false;
          if(items.error_code == 0) {
            this.currentItem.attributes.push(items.attribute);
          }
            this.newAttr.name = '';
            this.newAttr.value = '';
          this.requestInProgress = false;
        });

    }

    editAttr(attr:any){

        if(!attr.value || !attr.name) {
          return
        }

        this.requestInProgress = true;
        this._http.post(
            "/diamond/editAttribute",
            attr
        ).subscribe(items => {
          this.requestInProgress = false;
          this.requestInProgress = false;
        });

    }

    removeAttribute(attr:any){

        if(!attr.value || !attr.name) {
          return
        }

        this.requestInProgress = true;
        this._http.post(
            "/diamond/removeAttribute",
            attr
        ).subscribe(items => {
          this.currentItem.attributes.splice(this.currentItem.attributes.indexOf(attr), 1)
          this.requestInProgress = false;
        });

    }

    private getDiamondList() {
        this.isLoading = true;
        this._http.get(
            "/diamonds.json"
        ).subscribe(items => {
                items.diamonds.forEach((el:any)=>{
                    if(el.mounted) {
                      this.diamonds.push(el);
                      this.lotIds.push('' + el.lot_id);
                    }

                    if(this.haveMounted(el)) {
                      this.jewelryTypes.push(el.mounted);
                    }

                    if(el.pair && el.pair.mounted) {
                      this.diamonds.push(el.pair);
                      this.lotIds.push('' + el.pair.lot_id);

                      if(this.haveMounted(el.pair)) {
                        this.jewelryTypes.push(el.pair.mounted);
                      }
                    }

                    let flag = true;
                    this.locations.forEach((curel) => {
                      if(flag && ''+curel.toLowerCase() == el.location.toLowerCase()) {
                        flag = false;
                      }
                    })
                    if(flag && el.location) {
                      this.locations.push(el.location);
                    }
                })
                this.isLoading = false;
                this.filterDiamonds();
            });
    }

    haveMounted(item){
      let flag = true;
      if(!item.mounted) {
        return  false;
      }
      this.jewelryTypes.forEach(el => {
        if(flag && item.mounted == el) {
          flag = false;
        }
      })
      return flag;
    }

    toggItems(item:any, add:boolean, type:string){
        let flag:any = false;
        this.editingUser[type].forEach((el, i) => {
            if(el == item.text && flag === false) {
                flag = i;
            }
        })

        if(flag === false) {
            if(add) {
                this.editingUser[type].push(item.text);
            }
        }else{
            if(!add) {
                this.editingUser[type].splice(flag, 1)
            }
        }
    }
    triggerClick(event:any){
      if($(event.target).closest('.dropdown-menu').length > 0) {
        return;
      }
      $('body').trigger('click')
    }
    private getUserArrayIndexById(userId: number) {
        var index: number;

        this.collections.forEach((user, i) => {
            if (user.id == userId) {
                index = i;
                return;
            }
        });

        return index;
    }

    performSearch(search) {
        this.search = search;
        this._searchStrem.next(search);
    }

    getCollections() {
        return this._http.get(
            "/collection/all"
        );
    }

    refreshValue(val:any, type:string, sType?:string){
      if(sType) {
        this.editingUser[type][sType] = [];
        val.forEach((el)=>{
          this.editingUser[type][sType].push(el.text)
        })
        return;
      }
      this.editingUser[type] = [];
      val.forEach((el)=>{
        this.editingUser[type].push(el.text)
      })
    }

    changeListner(event) {
      var reader = new FileReader();
      var image = this.el.nativeElement;
      reader.onload = (e) => {
          var src = e.target['result'];
          this.imageBace = src;
          image.src = src;
      };

      if(event.target.files[0]) {
        reader.readAsDataURL(event.target.files[0]);
      }

    }
    refresh(){
      this.imgInput.nativeElement.value = "";
      this.imageBace = '';
      this.el.nativeElement.src = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/jewlary/jewlary.component.ts